import React, { useState, useEffect } from "react";
import {
  FaUser, FaClock, FaBox, FaTools, FaRegCalendarCheck, FaBars,
} from "react-icons/fa";
import { Outlet, Link } from "react-router-dom";
import logo from "../../../Assets/securent 2 (1).svg";
import profileIcon from "../../../Assets/profile.svg"; // Profile icon image
import Cookies from "js-cookie"; // If not already installed, run `npm install js-cookie`
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [schemesOpen, setSchemesOpen] = useState(false); // State for dropdown
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(window.scrollY);
  const navigate = useNavigate();

  const [activeSection, setActiveSection] = useState('');
  const handleLogout = () => {
    // Remove admin data from cookies
    Cookies.remove("admin");
    // Redirect to login page
    navigate("/admin/login");
  };

  const handleLinkClick = (section) => {
    setActiveSection(section);
    closeSidebar(); // Close sidebar after click
  };

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;
    setIsNavbarVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
    setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="flex min-h-screen flex-col bg-[#EFF2F7]">
      <div className="flex flex-1">
        {/* Toggle Button for mobile */}
        {!sidebarOpen && (
          <button
            className="fixed mt-4 left-4 z-50 text-[#1C50A3] text-2xl md:hidden"
            onClick={() => setSidebarOpen(!sidebarOpen)} // Toggle sidebar open/close
          >
            <FaBars />
          </button>
        )}
        <aside className={`fixed top-0 left-0 h-full w-64 bg-[#1C50A3] text-white flex flex-col pt-16 box-border rounded-tr-[100px] ${sidebarOpen ? 'block' : 'hidden'} md:block ${sidebarOpen ? 'z-[60]' : ''} sm:z-[60] md:z-auto`} style={{ zIndex: sidebarOpen ? 60 : 'auto' }}>

          {/* Logo at the top */}
          <div className="p-2 flex justify-center items-center">
            <img src={logo} alt="Securenet Logo" className="h-6 w-auto box-border" />
          </div>

          <div className="flex-1 pl-6 pt-4 mt-6 flex flex-col overflow-y-auto">
            <nav className="flex-1">
              <ul className="space-y-4">
                <li>
                  <Link
                    to="registered-customer"
                    className={`flex items-center w-full py-2 px-4 rounded-l-full transition duration-300 text-left ${activeSection === 'registered-customer' ? 'bg-[#EFF2F7] text-[#1C50A3]' : 'hover:bg-[#EFF2F7] hover:text-[#1C50A3]'}`}
                    onClick={() => handleLinkClick('registered-customer')}
                  >
                    <FaUser className={`group-hover:text-[#1C50A3] ${activeSection === 'registered-customer' ? 'text-[#1C50A3]' : ''}`} />
                    <span className={`ml-5 font-semibold ${activeSection === 'registered-customer' ? 'text-[#1C50A3]' : 'group-hover:text-[#1C50A3]'}`}>Registered Customer</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="agreement-details"
                    className={`flex items-center w-full py-2 px-4 rounded-l-full transition duration-300 text-left ${activeSection === 'agreement-details' ? 'bg-[#EFF2F7] text-[#1C50A3]' : 'hover:bg-[#EFF2F7] hover:text-[#1C50A3]'}`}
                    onClick={() => handleLinkClick('agreement-details')}
                  >
                    <FaUser className={`group-hover:text-[#1C50A3] ${activeSection === 'agreement-details' ? 'text-[#1C50A3]' : ''}`} />
                    <span className={`ml-5 font-semibold ${activeSection === 'agreement-details' ? 'text-[#1C50A3]' : 'group-hover:text-[#1C50A3]'}`}>Agreement-Details</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="registered/product"
                    className={`flex items-center w-full py-2 px-4 rounded-l-full transition duration-300 text-left ${activeSection === 'registered/product' ? 'bg-[#EFF2F7] text-[#1C50A3]' : 'hover:bg-[#EFF2F7] hover:text-[#1C50A3]'}`}
                    onClick={() => handleLinkClick('registered/product')}
                  >
                    <FaBox className={`group-hover:text-[#1C50A3] ${activeSection === 'registered/product' ? 'text-[#1C50A3]' : ''}`} />
                    <span className={`ml-5 font-semibold ${activeSection === 'registered/product' ? 'text-[#1C50A3]' : 'group-hover:text-[#1C50A3]'}`}>Registered Product</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="WarrantyExtended"
                    className={`flex items-center w-full py-2 px-4 rounded-l-full transition duration-300 text-left ${activeSection === 'WarrantyExtended' ? 'bg-[#EFF2F7] text-[#1C50A3]' : 'hover:bg-[#EFF2F7] hover:text-[#1C50A3]'}`}
                    onClick={() => handleLinkClick('WarrantyExtended')}
                  >
                    <FaClock className={`group-hover:text-[#1C50A3] ${activeSection === 'WarrantyExtended' ? 'text-[#1C50A3]' : ''}`} />
                    <span className={`ml-5 font-semibold ${activeSection === 'WarrantyExtended' ? 'text-[#1C50A3]' : 'group-hover:text-[#1C50A3]'}`}>Warranty</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="ProductRepair"
                    className={`flex items-center w-full py-2 px-4 rounded-l-full transition duration-300 text-left ${activeSection === 'ProductRepair' ? 'bg-[#EFF2F7] text-[#1C50A3]' : 'hover:bg-[#EFF2F7] hover:text-[#1C50A3]'}`}
                    onClick={() => handleLinkClick('ProductRepair')}
                  >
                    <FaTools className={`group-hover:text-[#1C50A3] ${activeSection === 'ProductRepair' ? 'text-[#1C50A3]' : ''}`} />
                    <span className={`ml-5 font-semibold ${activeSection === 'ProductRepair' ? 'text-[#1C50A3]' : 'group-hover:text-[#1C50A3]'}`}>Repair & Service</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="CustomerAwr"
                    className={`flex items-center w-full py-2 px-4 rounded-l-full transition duration-300 text-left ${activeSection === 'CustomerAwr' ? 'bg-[#EFF2F7] text-[#1C50A3]' : 'hover:bg-[#EFF2F7] hover:text-[#1C50A3]'}`}
                    onClick={() => handleLinkClick('CustomerAwr')}
                  >
                    <FaTools className={`group-hover:text-[#1C50A3] ${activeSection === 'CustomerAwr' ? 'text-[#1C50A3]' : ''}`} />
                    <span className={`ml-5 font-semibold ${activeSection === 'CustomerAwr' ? 'text-[#1C50A3]' : 'group-hover:text-[#1C50A3]'}`}>Customer Awr</span>
                  </Link>
                </li>

                {/* Schemes with Dropdown */}
                <li>
                  <button
                    onClick={() => setSchemesOpen(!schemesOpen)}
                    className={`flex items-center w-full py-2 px-4 rounded-l-full transition duration-300 text-left ${activeSection === 'Schemes' ? 'bg-[#EFF2F7] text-[#1C50A3]' : 'hover:bg-[#EFF2F7] hover:text-[#1C50A3]'}`}
                  >
                    <FaRegCalendarCheck className={`group-hover:text-[#1C50A3] ${activeSection === 'Schemes' ? 'text-[#1C50A3]' : ''}`} />
                    <span className={`ml-5 font-semibold ${activeSection === 'Schemes' ? 'text-[#1C50A3]' : 'group-hover:text-[#1C50A3]'}`}>Schemes</span>
                    <span className="ml-auto">{schemesOpen ? "▲" : "▼"}</span>
                  </button>
                  {schemesOpen && (
                    <div className="flex mt-2 ml-6">
                      <div className="border-l-2 border-[rgba(247,247,247,0.5)]"></div>
                      <div className="ml-4 flex-1 space-y-2">
                        <Link
                          to="Scheme"
                          className={`block py-2 px-4 font-semibold rounded-l-full transition duration-300 ${activeSection === 'Scheme' ? 'bg-[#EFF2F7] text-[#1C50A3]' : 'bg-[rgba(247,247,247,0.1)] hover:bg-[#EFF2F7] hover:text-[#1C50A3]'}`}
                          onClick={() => handleLinkClick('Scheme')}
                        >
                          Create Scheme
                        </Link>
                        <Link
                          to="allScheme"
                          className={`block py-2 px-4 font-semibold rounded-l-full transition duration-300 ${activeSection === 'allScheme' ? 'bg-[#EFF2F7] text-[#1C50A3]' : 'hover:bg-[#EFF2F7] bg-[rgba(247,247,247,0.1)] hover:text-[#1C50A3]'}`}
                          onClick={() => handleLinkClick('allScheme')}
                        >
                          All Schemes
                        </Link>
                        <Link
                          to="CustomerScheme"
                          className={`block py-2 px-4 font-semibold rounded-l-full transition duration-300 ${activeSection === 'CustomerScheme' ? 'bg-[#EFF2F7] text-[#1C50A3]' : 'hover:bg-[#EFF2F7] bg-[rgba(247,247,247,0.1)] hover:text-[#1C50A3]'}`}
                          onClick={() => handleLinkClick('CustomerScheme')}
                        >
                          Customer Scheme
                        </Link>
                      </div>
                    </div>
                  )}
                </li>
              </ul>
            </nav>
          </div>
        </aside>

        {/* Overlay for mobile view */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
            onClick={closeSidebar}
          ></div>
        )}

        {/* Main Content */}
        <main
          className={`flex-1 p-6 overflow-y-auto transition-all duration-300 ease-in-out ${sidebarOpen ? "" : "ml-0"} md:ml-64`}
          style={{
            position: sidebarOpen ? "relative" : "static",
            zIndex: 10,
          }}
        >
          {/* Navbar */}
          <div
            className={`flex justify-between items-center py-4 px-6 fixed w-full top-0 left-0 pr-14 transition-transform duration-300 ${isNavbarVisible ? "translate-y-0" : "-translate-y-full"}`}
          >
            {/* Profile Icon and Dropdown */}
            <div className="ml-auto flex items-center space-x-3 relative">
              <img
                src={profileIcon}
                alt="Profile Icon"
                className="w-10 h-10 rounded-l-full cursor-pointer"
              />

              <div className="flex flex-col items-center relative">
                <div className="flex items-center space-x-1">
                  <span className="font-medium text-gray-800 mr-2">Securenet</span>
                  <div
                    className="bg-white rounded-full mt-1 shadow-md flex items-center justify-center w-6 h-6 cursor-pointer"
                    onClick={toggleDropdown}
                  >
                    <span className="text-[#1C50A3] text-xs">▼</span>
                  </div>
                </div>
                <p className="text-sm text-gray-600">Admin</p>

                {/* Dropdown Menu */}
                {isDropdownVisible && (
                  <div className="absolute top-6 right-0 bg-white shadow-md rounded-md py-2 px-4 w-30">
                    <button
                      onClick={handleLogout}
                      className="flex items-center space-x-2 text-red-500 text-sm font-medium hover:bg-red-50 py-1 px-2 rounded-md w-full text-left"
                    >
                      <i className="fas fa-sign-out-alt text-red-500"></i>
                      <span>Logout</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="max-w-7xl mx-auto mt-10">
            <Outlet /> {/* Render nested routes here */}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;
